import { FunctionComponent } from 'react'
import { Location, Navigate, useLocation } from 'react-router-dom'
import styles from './meal.module.scss'
import { useAuth } from '@/modules/context/AuthContext.tsx'
import MealHandler from './mealHandler/mealHandler.tsx'

const MealPage: FunctionComponent = () => {
    const { user } = useAuth()

    const urlDaycare: Location = useLocation()
    const urlSearchParams: URLSearchParams = new URLSearchParams(urlDaycare.search)

    return user?.currentDaycare && user.currentDaycareRights.hasMealAccess ? (
        <div className={styles.PagePosition}>
            <MealHandler
                currentDaycare={user.currentDaycare}
                defaultDate={urlSearchParams.get('date')}
                defaultSections={urlSearchParams.get('sections')}
            />
        </div>
    ) : (
        <Navigate to='/' replace />
    )
}

export default MealPage
